import React from 'react'

function Donate({id}) {
  return (
    <section className="w-full bg-[#102343] mt-8 py-5 px-5 sm:px-[86px] pb-[122px]" id={id}>
        <h1 className=' text-white font-[500] text-[32px] sm:text-[64px] text-center mb-3'>Let’s Make A Change</h1>
        <p className=' text-white font-[500] text-[16px] sm:text-[24px] text-center'>Here are some ways you can donate:</p>
        <div className=' mt-[56px] grid sm:grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3'>
            <div className=' rounded-xl bg-[#EFF3FB] py-[72px] px-[50px]'>
                <p className=' font-[900] text-[32px] text-[#102343] text-center mb-[2px]'>IRETI-OLA FOUNDATION</p>
                <p className=' font-[900] text-[24px] text-[#102343] text-center mb-[49px]'>(First Bank)</p>
                <p className=' font-[900] text-[32px] text-[#102343] text-center mb-[49px]'>2034267309</p>
                <p className=' font-[900] text-[32px] text-[#102343] text-center mb-[49px]'>USD ACCOUNT</p>
            </div>
            <div className=' rounded-xl bg-[#EBF2EC] py-[72px] px-[50px]'>
                <p className=' font-[900] text-[32px] text-[#102343] text-center mb-[2px]'>IRETI-OLA FOUNDATION</p>
                <p className=' font-[900] text-[24px] text-[#102343] text-center mb-[49px]'>(First Bank)</p>
                <p className=' font-[900] text-[32px] text-[#102343] text-center mb-[49px]'>2034267316</p>
                <p className=' font-[900] text-[32px] text-[#102343] text-center mb-[49px]'>EUR ACCOUNT</p>
            </div>
            <div className=' rounded-xl bg-[#FFFFFF] py-[72px] px-[50px]'>
                <p className=' font-[900] text-[32px] text-[#102343] text-center mb-[2px]'>IRETI-OLA FOUNDATION</p>
                <p className=' font-[900] text-[24px] text-[#102343] text-center mb-[49px]'>(First Bank)</p>
                <p className=' font-[900] text-[32px] text-[#102343] text-center mb-[49px]'>2034265745</p>
                <p className=' font-[900] text-[32px] text-[#102343] text-center mb-[49px]'>NAIRA ACCOUNT</p>
            </div>
        </div>
    </section>
  )
}

export default Donate